import React from "react";

function BMIGuideline() {
    return (
        <>
            <div className="row">
                <div className="col-4 bg-primary pl-5">
                    <h5>Management Guideline</h5>
                </div>

                <table className="table table-bordered ">
                    <tbody>
                        <tr>
                            <td style={{ backgroundColor: "lightgreen", width: "33%" }}>
                                <strong>0 - Low Risk (Routine clinical note)</strong>
                            </td>
                            <td style={{ backgroundColor: "yellow", width: "33%" }}>
                                <strong>1 - Medium Risk (Observe)</strong>
                            </td>
                            <td style={{ backgroundColor: "red", width: "33%" }}>
                                <strong>2 or more High Risk (Threat)</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ verticalAlign: "top" }}>
                                <p>Repeat screening Hospital - weekly care Homes - monthly Community - annually for special groups e.g those > 75 yrs</p>
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                                <p>Document dietary intake for 3 days</p>
                                <p>If adequate - little concern and repeat screening (Hospital-weekly, Care Home -at least monthly or Community - at least every 2-3 months)</p>
                                <p>if inadequate - clinical concern - follow local policy, set goals improve and increase overall nutritional intake, monitor and review care plan regularly.</p>
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                                <p>Refer to dietitian, Nutritional Support Team or implement local policy </p>
                                <p>Set goals, improve and increase overall nutritional intake</p>
                                <p>monitor and review care plan Hospital - weekly, Care Home - monthly, Community - monthly</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default BMIGuideline;
